export enum Role {
    VIEWER = 'VIEWER',
    CONTRIBUTOR = 'CONTRIBUTOR',
    MANAGER = 'MANAGER'
}
